import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Crm/complaints'

export default {
  namespaced: true,
  state: {
    loading: false,
    complaints: {
      data: [],
      grandTotals: {
        mtd: 0,
        ytd: 0,
        chartData: {
          monthly: {
            series: [],
            labels: [],
          },
          yearly: {
            series: [],
            labels: [],
          },
        },
      },
    },
    /* Filter Params */
    complaintParams: {
      sdate: `${moment().format('YYYY')}-01-01`,
      edate: moment().format('YYYY-MM-DD'),
      type: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    complaints(state) {
      return state.complaints
    },
    /* Filter Params */
    complaintParams(state) {
      return state.complaintParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_COMPLAINTS(state, data) {
      state.complaints = data
    },
    /* RESET MUTATIONS */
    RESET_COMPLAINTS(state) {
      state.complaints = {
        data: [],
        grandTotals: {
          mtd: 0,
          ytd: 0,
          chartData: {
            monthly: {
              series: [],
              labels: [],
            },
            yearly: {
              series: [],
              labels: [],
            },
          },
        },
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_COMPLAINTS')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_COMPLAINTS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
